module.exports = __webpack_public_path__ + "media/Z47.337dd41b.mp3";